/**
 * Allowed platform identifiers used across the app
 * Use const assertion for type safety without runtime overhead
 */
export const ALLOWED_PLATFORMS = [
  'humanoo',
  'fairfamily',
  'wlp',
  'mufaroo',
  'telus',
  'heywell',
] as const;

/**
 * Platform type derived from allowed platforms
 * Automatically stays in sync with ALLOWED_PLATFORMS changes
 */
export type Platform = (typeof ALLOWED_PLATFORMS)[number];
